// This file is automatically generated. Do not edit manually.

import { ShopOrderLine } from "src/api/generated/erp/db/types/tables/shopOrderLine";
import { ShopOrderLineUpdateService_UpdateRequest } from "src/api/generated/erp/production/service/shopOrderLine/shopOrderLineUpdateService";
import { PartView } from "src/api/generated/erp/db/types/tables/partView";
import { ShopOrderLineView } from "src/api/generated/erp/db/types/tables/shopOrderLineView";
import { ShopOrderOperationView } from "src/api/generated/erp/db/types/tables/shopOrderOperationView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ShopOrderLineFormApi {
	export async function getInitData(args: {
		shopOrderId: number;
		shopOrderLineId: number | null | undefined;
	}): Promise<ShopOrderLineFormApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBom/getInitData",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
				shopOrderLineId: args.shopOrderLineId,
			},
		});
		return response as ShopOrderLineFormApi_InitData;
	}

	export async function insert(args: {
		shopOrderLine: ShopOrderLine;
		shopOrderId: number;
		partId: number;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBom/insert",
			method: "POST",
			data: {
				shopOrderLine: args.shopOrderLine,
				shopOrderId: args.shopOrderId,
				partId: args.partId,
			},
		});
		return response as number;
	}

	export async function update(args: {
		request: ShopOrderLineUpdateService_UpdateRequest;
		partId?: number | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBom/update",
			method: "POST",
			data: {
				request: args.request,
				partId: args.partId,
			},
		});
		return response as number;
	}
}

export interface ShopOrderLineFormApi_InitData {
	defaultReferenceNo: number;
	part: PartView | null | undefined;
	shopOrderLine: ShopOrderLineView | null | undefined;
	shopOrderOperationOptions: Array<ShopOrderOperationView>;
	siteId: number;
}
